/**
 * ikas gomulu mod yardimcilari — saf fonksiyonlar (docs/faz3-ikas-spec.md §6,
 * docs/faz5-arayuz-spec.md §2 "/embed/ikas"). `window.top` jsdom'da guvenilir
 * bicimde yeniden tanimlanamadigindan bu fonksiyonlar test edilebilirlik icin
 * sahte `Window`-benzeri nesneler kabul eder; gercek kullanimda parametre
 * verilmez (varsayilan global `window`).
 */

export interface FrameLike {
  self: unknown;
  top: unknown;
}

/** `window.self !== window.top` ise sayfa bir iframe icinde acilmis demektir. */
export function isEmbedded(w: FrameLike = window): boolean {
  return w.self !== w.top;
}

/** Sondaki `/` haric taban yolu tekillestirir, sonuna TEK `/` ekler ('' → '/'). */
function normalizeBase(base: string): string {
  if (!base) return "/";
  return base.endsWith("/") ? base : `${base}/`;
}

/**
 * Ust pencerede (window.top) acilacak tam sayfa URL'i — VITE_BASE'e saygili
 * (Faz 6 kesimi sonrasi varsayilan `/`; gecis donemi override'i `/v2/`
 * olabilirdi). `path` bastaki `/` OLMADAN verilir (ör. "ozet", "giris").
 */
export function topPanelUrl(path: string, base = import.meta.env.BASE_URL, origin = window.location.origin): string {
  return `${origin}${normalizeBase(base)}${path}`;
}

/** URL sorgu dizesinden `storeName`'i okur; yoksa bos string (backend yalniz varligini arar). */
export function readStoreName(search: string): string {
  return new URLSearchParams(search).get("storeName") ?? "";
}
